import { Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { EmailVerificationDto } from '@shared/dtos/email-verification.dto';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EmailVerificationService } from '../../services/email-verification.service';
import { MessageService } from '../../services/message.service';

@Component({
  selector: 'form-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss'],  
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EmailVerificationComponent),
      multi: true,
    },
  ],
})
export class EmailVerificationComponent implements OnInit, OnDestroy, ControlValueAccessor {
  private destroyed$: Subject<void> = new Subject<void>();
  onChange: (value: EmailVerificationDto) => void = () => {};
  public formGroup: UntypedFormGroup;
  public email: string;


  public emailVerification: EmailVerificationDto = {
    code: '', 
    uuid: '',
    email: '',
  };

  constructor(
    private emailVerificationService: EmailVerificationService,
    private messageService: MessageService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {    
    this.emailVerificationService.getEmail()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((email) => {
        this.email = email;
      });
    this.generateCode();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  writeValue(value: EmailVerificationDto): void {
    this.emailVerification = value || {
      uuid: '',
      code: '',
      email: this.email,
    };
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void { }

  onAnswerChange(answer: string) {
    this.emailVerification.code = answer;
    this.onChange(this.emailVerification);
  }

  generateCode() {
    this.emailVerificationService.generateCode().subscribe((id) => {
      this.emailVerification.uuid = id.uuid;
      this.messageService.showInfo(this.translateService.instant('components.email-verification.email-send-success', {
        email: this.email
      }));
    });
  }
}
